import type { ModelAccent } from '../types/kit';

interface AccentClasses {
  text: string;
  bg: string;
  soft: string;
  border: string;
}

const accentMap: Record<ModelAccent, AccentClasses> = {
  airbnb: { text: 'text-airbnb', bg: 'bg-airbnb', soft: 'bg-airbnb-soft', border: 'border-airbnb' },
  arbitraje: { text: 'text-arbitraje', bg: 'bg-arbitraje', soft: 'bg-arbitraje-soft', border: 'border-arbitraje' },
  digital: { text: 'text-digital', bg: 'bg-digital', soft: 'bg-digital-soft', border: 'border-digital' },
};

export function getAccent(accent: ModelAccent): AccentClasses {
  return accentMap[accent];
}
